import { render, staticRenderFns } from "./Cart.vue?vue&type=template&id=495a44a7"
import script from "./Cart.vue?vue&type=script&lang=js"
export * from "./Cart.vue?vue&type=script&lang=js"
import style0 from "./Cart.vue?vue&type=style&index=0&id=495a44a7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports